import { FC, ReactNode } from "react";
import { StyledDashboard, StyledTitle } from "./dashboard.styled";
import Typography from '@mui/material/Typography';
import { Slide, ToastContainer } from "react-toastify";

interface DashboardProps {
  children: ReactNode;
  name: string;
}

const Dashboard: FC<DashboardProps> = ({ children, name }) => {
  const pageTitle: { [key: string]: string } = {
    "/Settings": "Settings",
    "/Cases": "Cases",
    "/QueryBuilder": "Query Builder",
    "/SavedQueries": "Saved Queries",
    "/UserDefinedLists": "User Defined Lists",
    "/QueryHistory": "Query History",
    "/OfflineQueriesRepository": "Offline Queries Repository",
    "/LogCollectionPlatform": "Log Collection Platform",
    "/ReportsList": "Reports List",
    "/Builder": "Builder",
    "/Assets": "Assets",
  };

  return (
    <StyledDashboard>
      {/* Toast hovers above the main component area */}
      <ToastContainer limit={3} transition={Slide} />

      {/* Component Area */}
      {children}
    </StyledDashboard>
  );
};

export default Dashboard;
